import { combineReducers } from 'redux'
import globalReducer from './global_reducer'
import membershipReducer from './membership_reducer'

export default combineReducers({
    globalReducer,
    membershipReducer
})